import { ref, computed } from 'vue'
import { defineStore } from 'pinia'

// 在 Setup Store 中：
// ref() 就是 state 属性
// computed() 就是 getters
// function() 就是 actions

export const useStore = defineStore('mobile', () => {
  const isMobile = ref(false)
  function setMobileMode(bool) {
    isMobile.value = bool
  }
  return {
    isMobile,
    setMobileMode
  }
})
